<template>
  <div>
    <div class="page-title">开具发票</div>
    <page-tab
      :tabs="tabs"
      :nowTab="nowTab"
      :paramsLabel="'index'"
    ></page-tab>
    <page-search
      :layout="['payer', 'payee', 'date', 'export']"
      @search="search"
      @exportTable="exportTable"
    ></page-search>
    <pageTable
      :loading="tableLoading"
      :col="col"
      :data="tableData"
      :total="total"
      :pageSize="pageSize"
      :page="page"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
    ></pageTable>
  </div>
</template>

<script>
import Vue from 'vue'
import pageTable from '@/components/pageCom/pageTable.vue'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import pageTab from '@/components/pageCom/pageTab.vue'
import pageSearch from '@/components/pageCom/pageSearch.vue'
import { invoiceFeeList, getNeedAddCount } from '@/api/invoice'
import { downFile } from '@/utils/file'
export default {
  name: 'feeInvoice',
  components: {
    pageTab,
    pageSearch,
    pageTable
  },
  mixins: [pageTableMixin],
  data() {
    return {
      tabs: [
        { text: 'UKEY', num: '', linkName: 'ukeyInvoice' },
        { text: '手续费', num: '', linkName: 'feeInvoice' }
      ],
      col: [
        { field: '', title: '序号', width: 50, titleAlign: 'left', columnAlign: 'left',
          formatter: (rowData, index) => {
            const num = (this.page - 1) * this.pageSize + (index + 1)
            return num
          }
        },
        { field: 'operate', title: '操作', width: 80, titleAlign: 'left', columnAlign: 'left', componentName: 'feeInvoiceOpe' },
        { field: 'account_num', title: '财务流水单号', width: 140, titleAlign: 'left', columnAlign: 'left' },
        { field: 'statement_num', title: '业务流水单号', width: 120, titleAlign: 'left', columnAlign: 'left' },
        { field: 'sct_no', title: '合同编号', width: 200, titleAlign: 'left', columnAlign: 'left' },
        { field: 'payment_date', title: '付款日期', width: 140, titleAlign: 'left', columnAlign: 'left' },
        { field: 'payer', title: '付款方', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'receiver', title: '收款方', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'money', title: '服务费金额', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'type', title: '类型', width: 80, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData) {
            const types = {
              '1': '收款', '2': '付款 ', '3': '解冻 ', '4': '冻结', '5': '服务费'
            }
            return `<span>${types[rowData['type']]}</span>`
          }
        },
        { field: 'status', title: '状态', width: 80, isResize: true, titleAlign: 'left', columnAlign: 'left',
          formatter: function() {
            return '<span>成功</span>'
          }
        }
      ],
      searchParams: ''
    }
  },
  computed: {
    nowTab() {
      return this.$route.name
    }
  },
  watch: {
    nowTab() {
      this.getData()
    }
  },
  methods: {
    initPage() {
      this.searchParams = ''
    },
    getNeedCount() {
      getNeedAddCount({
        tab_type: '2',
        payer: this.searchParams.payer || '',
        receiver: this.searchParams.payee || '',
        create_time_start: this.searchParams.date ? this.searchParams.date[0] : '',
        create_time_end: this.searchParams.date ? this.searchParams.date[0] : ''
      }).then(res => {
        const { code, result } = res
        if (code === 0) {
          this.tabs[0].num = '待开' + result.ukey
          this.tabs[1].num = '待开' + result.service
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
        }
      })
    },
    // 获取表格
    getData() {
      this.getNeedCount()
      this.tableLoading = true
      invoiceFeeList({
        payer: this.searchParams.payer || '',
        receiver: this.searchParams.payee || '',
        create_time_start: this.searchParams.date ? this.searchParams.date[0] : '',
        create_time_end: this.searchParams.date ? this.searchParams.date[0] : '',
        per_page: this.pageSize,
        page: this.page
      }).then(res => {
        this.tableLoading = false
        const { code, result } = res
        if (code === 0) {
          this.tableData = result.data
          this.total = result.count
        } else if (res.code !== 10008) {
          this.tableData = []
          this.total = 0
          this.$Message.info(res.msg)
        }
      })
    },
    // 搜索
    search(query) {
      // 返回的字段 payer payee date
      this.searchParams = query
      this.initTable()
      this.getData()
    },
    initTable() {
      this.page = 1
      this.pageSize = 30
      this.data = []
      this.total = 0
    },
    pageChange(page) {
      this.page = page
      this.getData()
    },
    pageSizeChange(size) {
      this.page = 1
      this.pageSize = size
      this.getData()
    },
    exportTable() {
      const url = process.env.VUE_APP_BASE_API + '/invoice/export_excel'
      const params = {
        table_type: '2',
        payer: this.searchParams.payer || '',
        receiver: this.searchParams.payee || '',
        create_time_start: this.searchParams.date ? this.searchParams.date[0] : '',
        create_time_end: this.searchParams.date ? this.searchParams.date[0] : '',
        per_page: this.pageSize,
        page: this.page
      }
      downFile(url, params)
    }
  }
}
// 自定义列组件
Vue.component('feeInvoiceOpe', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    makeout() {
      this.$router.push({
        name: 'makeout', params: { type: 'fee', id: this.rowData.id }
      })
    },
    detail() {
      this.$router.push({
        name: 'invoiceDetail', params: { type: 'fee', id: this.rowData.id }
      })
    }
  },
  render: function(h) {
    if (this.rowData.has_bill === '0') {
      // 开发票
      return h('div', {
        class: 'link-btn',
        on: {
          click: this.makeout
        }
      }, '开发票')
    } else {
      // 查看发票
      return h('div', {
        class: 'link-btn link-btn-green',
        on: {
          click: this.detail
        }
      }, '查看发票')
    }
  }
})
</script>
